import React from "react"
import {Container, Navbar} from "react-bootstrap";
import LogoName from '../assets/headerLogo.jpg'
import '../styles/App.css';
import {useLocation} from "react-router-dom";

const TopNavMain = () => {
    const location = useLocation();
    return (
        <Navbar className="horizontal-1st-nav horizontal-nav secondary-color">
            <Container>
                <Navbar.Brand className="nav-brand">
                    <img src={LogoName} alt="logo"/>
                </Navbar.Brand>
                <Navbar.Toggle/>
                <Navbar.Collapse className="justify-content-end">
                    <Navbar.Text className={location.pathname === '/documentation' ? "active-nav" : "inactive-nav"}>
                        <a href="/documentation">Documentation</a>
                    </Navbar.Text>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default TopNavMain;
